


import { Component, Prop, Vue } from "vue-property-decorator";

/* LE JETON ET CE QUI LE PORTE — servi apres la generation et a l'affichage.

   Le jeton entier, « Copier », puis les deux en-tetes acceptes par l'API : c'est
   ce qu'on transmet au client pour configurer son MCP ou son programme. */
@Component
export default class ApiKeyTokenBlock extends Vue {
    @Prop( { default: "" } )
    readonly Token!: string;

    private copied: boolean = false;

    private async copy(): Promise<void> {
        try {
            await navigator.clipboard.writeText( this.Token );
            this.copied = true;
        } catch( error ) {
            /* Presse-papiers refuse : le jeton reste affiche et se selectionne
               d'un clic. */
            this.copied = false;
        }
    }
}
